// extracted by mini-css-extract-plugin
module.exports = {"directionIcon":"DirectionIcon_directionIcon__3eOvv","inbound":"DirectionIcon_inbound__3jNVM","outbound":"DirectionIcon_outbound__36oZ3"};